import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortableArrayDirective } from './sortable-array.directive';


@NgModule({
  declarations: [
    SortableArrayDirective,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    SortableArrayDirective,
  ],
})
export class DirectivesModule {
}
